<script>
    import categories from "../stores/categories";
    import {categorySearch} from "../lib/requests";
    import {findNode, backPath, setFocusTo} from "../lib/lib";

    export let categoryId = null;
    export let showParentPathOnly = null;

    let category = null;
    let categoryPath = "";
    let name = "";

    let results = [];
    let resultIndex = -1;
    let dropdownVisible = false;
    let inputVisible = false;
    let noResults = false;

    const showNameInput = () => {
        inputVisible = true;
        setFocusTo('cat-parent-name');
    }

    const hideNameInput = () => {
        inputVisible = false;
    }

    const onInputKeyUp = (event) => {
        if (event.key === "Enter") {
            if (name !== '') {
                getResults();
            }
        } else if (event.key === 'ArrowDown') {
            gotoNextResult();
        } else if (event.key === 'Escape') {
            cancelSelect();
        }
    }

    const onOptionKeyUp = (event) => {
        if (event.key === 'ArrowDown') {
            gotoNextResult();
        } else if (event.key === 'ArrowUp') {
            gotoPrevResult();
        } else if (event.key === 'Escape') {
            cancelSelect();
        }
    }

    const gotoNextResult = () => {
        if (resultIndex === -1) {
            resultIndex = 0;
        } else if (resultIndex < results.length - 1) {
            resultIndex++;
        }
        setFocusTo("option-" + results[resultIndex].id, true);
    }

    const gotoPrevResult = () => {
        if (resultIndex > 0) {
            resultIndex--;
        }
        setFocusTo("option-" + results[resultIndex].id, true);
    }

    const onSelect = (option) => {
        categoryId = option.id;
        category = findNode(option.id, $categories.tree);
        name = category.name_el;
        categoryPath = option.parents_path.join(" » ");
        console.log("categoryPath", categoryPath);
        // if (!showParentPathOnly) {
        //     categoryPath += "»" + category.name_el;
        // }
        resetControl();
    }

    const cancelSelect = () => {
        if (category) {
            name = category.name_el;
        }
        resetControl();
    }

    const resetControl = () => {
        inputVisible = true;
        dropdownVisible = false;
        results = [];
        noResults = false;
        setFocusTo('cat-parent-name');
    }

    const removeMath = () => {
        categoryId = null;
        category = null;
        name = '';
        categoryPath = '';
        inputVisible = true;
        dropdownVisible = false;
        noResults = false;
    }

    const getResults = async () => {
        const [err, res] = await categorySearch(name);

        if (err) {
            alert('error ' + err)
            return;
        }

        results = res.results;
        resultIndex = -1;
        dropdownVisible = results.length > 0;
        noResults = results.length === 0;
    }

    $:{
        if (categoryId !== null && category === null) {
            category = findNode(categoryId, $categories.tree);
            if (category) {
                name = category.name_el;
                categoryPath = backPath(category.id, $categories.tree);
            }
        }
    }
</script>

<div class="autocomplete">
    <!--{#if geo !== null}-->
    <div class="input-group">
        {#if inputVisible}
            <input type="text" class="form-control" id="cat-parent-name" bind:value="{ name }"
                   on:keyup="{ onInputKeyUp }" on:focusout="{ hideNameInput }" placeholder="{categoryPath}">
            {#if noResults}
                <i class="fa fa-warning no-results"></i>
            {/if}
        {:else}
            <input type="text" class="form-control" value="{ categoryPath }" on:focus="{ showNameInput }">
        {/if}
        <span class="input-group-addon" style="cursor: pointer" title="Ακύρωση αντιστοίχισης" on:click="{ removeMath }"><i
                class="fa fa-remove"></i></span>
    </div>

    {#if dropdownVisible}
        <div class="autocomplete-dropdown">
            {#each results as option, index}
                <a href="#" class="option" class:selected={ category && category.id === option.id }
                   class:focused={ resultIndex === index } id="option-{ option.id }"
                   on:keyup|preventDefault|stopPropagation="{ onOptionKeyUp }"
                   on:click={ () => onSelect(option) }>
                    <span class="name">{ option.name_el }</span>
                    <span class="path">{ option.parents_path }</span>
                </a>
            {/each}
        </div>
    {/if}
    <!--{/if}-->
</div>

<style>
    .autocomplete {
        position: relative;
    }

    .autocomplete-dropdown {
        position: absolute;
        left: 0;
        right: 0;
        top: 33px;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 3px;
        padding: 5px;
        z-index: 3000;
    }

    .autocomplete-dropdown .option {
        display: block;
        padding: 5px;
    }

    .autocomplete-dropdown .option:after {
        content: "";
        clear: both;
        display: table
    }

    .autocomplete-dropdown .option.selected {
        /*background: #f9f9f9;*/
        background: var(--item-selected-background);
    }

    .autocomplete-dropdown .option .name {
        display: block;
        float: unset !important;
        padding-bottom: 2px;
    }

    /*.autocomplete-dropdown .option .category {*/
    /*    display: block;*/
    /*    float: left;*/
    /*    margin-left: 10px;*/
    /*    color: #ababab;*/
    /*}*/
    .autocomplete-dropdown .option .path {
        display: block;
        float: unset !important;
        color: #a5a5a5;
        text-decoration: none;
        padding-left: 5px;
    }

    .autocomplete-dropdown .option:hover, .autocomplete-dropdown .option.focused {
        background: var(--item-hover-background);
    }

    .input-group {
        position: relative;
    }

    .input-group .no-results {
        position: absolute;
        top: 50%;
        right: 45px;
        transform: translateY(-50%);
        color: red;
        z-index: 2000;
    }
</style>